export default (state, action) => {
  const updatedUser = { ...state.user }
  updatedUser.notifications = updatedUser.notifications
    .filter(notification => !action.payload.ids.includes(notification.id))

  return { ...state, user: updatedUser }
}
